import { useApi } from "../../../swr/useApi";
import { api } from "../../api_client";

export interface CatalogFacets {
  ramOptions: string[];
  storageOptions: string[];
  cpuOptions: string[];
  brands: string[];
  categories: string[];
  conditions: string[];
  screenSizes: string[];
  colors: string[];
}

// TODO: collapse to typed productVariantsService.getCatalogFacets() after next `npm run generate:api`.
export function useCatalogFacets() {
  return useApi<CatalogFacets>("catalog-facets", async () =>
    api.get<CatalogFacets>("/api/v1/product-variants/catalog-facets"),
  );
}
